import { axios } from '@complispace/cs-design-system';
import sessionManager from '@/store/modules/session/sessionManager';
import { isSupportMode } from './supportMode';

let isHandling401 = false;
let isHandling403 = false;

export function handle401HubLogout(store, router) {
  return async (error) => {
    if (error.response?.status === 401 && !isHandling401 && store.getters['hub/isEnabled']) {
      isHandling401 = true;
      try {
        await store.dispatch('authorisation/logout', false, { root: true });
      } catch (logoutError) {
        console.error('[401 Handler] Logout failed:', logoutError);
      }
    }
    return Promise.reject(error);
  };
}

export function handle403AccessDenied(store, router) {
  return async (error) => {
    if (error.response?.status === 403 && !isHandling403 && store.getters['hub/isEnabled']) {
      isHandling403 = true;
      router.push('/access-denied');
    }
    return Promise.reject(error);
  };
}

const isOwnApiUrl = (url) =>
  [process.env.CONTENT_ENGINE_URL, process.env.QUICK_LINKS_API_URL]
    .filter(Boolean)
    .some((baseUrl) => url === baseUrl || url.startsWith(`${baseUrl}/`));

export function applySupportSiteHeaders(config) {
  // Add these headers only when support staff have switched into a tenant (a target site is set).
  // Without a target site, requests go to the support site as normal, using the staff member's
  // own role. Other hosts never get the headers.
  if (!isSupportMode() || !sessionManager.getTargetSite() || !isOwnApiUrl(config.url || '')) {
    return config;
  }

  /* eslint-disable no-param-reassign */
  config.headers['x-site-uri'] = sessionManager.getXSiteUrl();
  config.headers['x-support-site-uri'] = sessionManager.getOwnSiteUrl();
  /* eslint-enable no-param-reassign */
  return config;
}

export function setupAxiosInterceptors(store, router) {
  axios.interceptors.request.use(applySupportSiteHeaders);
  axios.interceptors.response.use((response) => response, handle401HubLogout(store, router));
  axios.interceptors.response.use((response) => response, handle403AccessDenied(store, router));
}
